
import { Type, useReflectiveInjector } from '@tanbo/vue-di-plugin';
import LogoffModal from './logoffModal.vue'
import { defineComponent, reactive } from 'vue'
import { ConfigService } from '@/services/config.service';

export default defineComponent({
  components: {
    LogoffModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const injector = useReflectiveInjector()
    const config = injector.get(ConfigService as Type<ConfigService>)

    const viewModel = reactive({
      logoffSuccessContent: config.getLogoffSuccessContent || ''
    })

    function close() {
      emit('close', false)
      window.close()
    }

    function handleVerify() {
      window.close()
    }

    return {
      viewModel,
      props,
      close,
      handleVerify
    }
  }
})
